export const OFFSHORE_PCB_ID = 348;
